"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _MinusRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/MinusRound"));

// Generated by script, don't edit it please.
var MinusRound = (0, _createSvgIcon["default"])({
  as: _MinusRound["default"],
  ariaLabel: 'minus round',
  category: 'status',
  displayName: 'MinusRound'
});
var _default = MinusRound;
exports["default"] = _default;
module.exports = exports.default;